import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';

const PREFIX = 'stromo:';

/**
 * useState mit localStorage-Persistierung. Standard-Setter (Wert oder Callback)
 * funktioniert wie gewohnt — wir spiegeln den neuen Wert nach jeder Änderung
 * in den Storage. Bei JSON-Parse-Fehlern oder fehlendem Storage fallback auf
 * den initialen Wert.
 */
export function usePersistedState<T>(key: string, initial: T): [T, Dispatch<SetStateAction<T>>] {
  const storageKey = PREFIX + key;
  const [value, setValue] = useState<T>(() => {
    if (typeof window === 'undefined') return initial;
    try {
      const raw = window.localStorage.getItem(storageKey);
      if (raw == null) return initial;
      return JSON.parse(raw) as T;
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch {
      // Quota oder Privacy-Mode — schlucken, nicht crashen
    }
  }, [storageKey, value]);

  return [value, setValue];
}
